import { Injectable } from '@angular/core';
import { ComponentBase } from '../../../component-base';
import { MatDialog } from '@angular/material';
import { DrawingsHolderService } from '../drawings-holder.service';
import { PositionCalculatorService } from '../position-calculator.service';
import { TitleBlock } from '../object3D/TitleBlock/TitleBlock';
import { TitleBlockInfoComponent } from '../ng-components/title-block-info/title-block-info.component';
import { TitleBlockInfo } from '../object3D/TitleBlock/TitleBlockInfo';
import { TitleBlockComponent } from '../ng-components/title-block/title-block.component';
import { ProjectManagerService } from '../../project-manager.service';
import { Subject } from 'rxjs';
declare let THREE: any;

@Injectable()
export class DrawTitleBlockComponent extends ComponentBase {

    titleBlock: TitleBlock = null;
    image: any;
    loader = new THREE.ImageLoader();
    titleBlockInfo: TitleBlockInfo = null;
    openSaveDialogSubscribtion = new Subject<boolean>();

    constructor(
        private dialog: MatDialog,
        private drawings: DrawingsHolderService,
        private positionCalculator: PositionCalculatorService,
        private projectManager: ProjectManagerService
    ) {
        super();
        this.disable();
    }

    clearTitleBlock() {
        this.titleBlockInfo = null;
    }
    addTitleBlock() {
        const project = this.projectManager.getCurrentProject();
        let data: any;
        // this.titleBlockInfo = new TitleBlockInfo(new Date());
        if (this.titleBlockInfo) {
            data = this.titleBlockInfo;
        }
        else if (project && project.draw_options
            && project.draw_options.titleBlockOptions && project.draw_options.titleBlockOptions.TopItems) {
            data = { ...project.draw_options.titleBlockOptions };
        }
        else if (project && project.draw_options && !project.draw_options.titleBlockOptions) {
            data = { ...project.draw_options };
        }
        else {
            data = new TitleBlockInfo(new Date());
        }
        this.drawings.canvas.remove(this.titleBlock);
        if (this.titleBlock && this.titleBlock.TopBlock) {
            this.drawings.canvas.remove(this.titleBlock.TopBlock);
            this.drawings.canvas.remove(this.titleBlock.LeftBlock);
            this.drawings.canvas.remove(this.titleBlock.RightBlock);
            this.drawings.canvas.remove(this.titleBlock.LegendBlock);
            this.drawings.canvas.remove(this.titleBlock.BottomBlock);
        }

        const dialogRef = this.dialog.open(TitleBlockInfoComponent, {
            width: '315px',
            height: '530px',
            position: {
                left: '0'
            },
            hasBackdrop: false,
            // data: this.titleBlock && this.titleBlock.userData.tb ? this.titleBlock.userData.tb : null
            data: data
        });

        dialogRef.afterClosed().subscribe((result) => {

            if (result.hasOwnProperty("remainData")) {
                this.titleBlockInfo = result.remainData;
            }
            else if (result.trigger === 'openSaveDialog') {
                this.openSaveDialogSubscribtion.next(true);
            }
            else if (result) {
                this.addSavedTitleBlock(result);
            }
            // console.log(this.projectManager.getCurrentProject());
        });
        // this.image =
    }

    addSavedTitleBlock(result) {
        if (result) {
            this.loader.load("../../../../../assets/images/feeney_logo.png",
                map => {
                    this.image = map;
                    this.titleBlock = new TitleBlock(this.image, result);
                    this.titleBlock.userData.tb = result.Cleared ? null : result;
                    if (!result.Cleared) {
                        this.drawings.canvas.add(this.titleBlock);

                        this.titleBlock.update(this.drawings.scale,
                            this.drawings.paperWidth, this.drawings.paperHeight,
                            this.drawings.paperBox.position);
                        this.drawings.canvas.add(this.titleBlock.TopBlock);
                        this.drawings.canvas.add(this.titleBlock.LeftBlock);
                        this.drawings.canvas.add(this.titleBlock.RightBlock);
                        this.drawings.canvas.add(this.titleBlock.LegendBlock);
                        this.drawings.canvas.add(this.titleBlock.BottomBlock);
                    }
                });
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/services/proTools/components/DrawTitleBlockComponent.ts